<template>
    <div class="app-content">
        <AppLoader v-if="contentLoader" />
        <div v-else class="app-content-inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AppLoader from '@fifa-bsm/bo-frontend-shared/components/AppLoader/AppLoader';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AppContent',
    components: {
        AppLoader,
    },
    computed: {
        ...mapGetters('Config', {
            contentLoader: 'contentLoader',
        }),
    },
});
</script>

<style lang="scss" scoped>
.app-content {
    position: relative;
    display: flex;
    overflow: auto;
    min-height: 0;
    flex: 1;

    .app-content-inner {
        flex: 1;
        padding: var(--spacing-md);
    }

    > .app-loader {
        background: rgb(240, 240, 240);
    }
}
</style>
